import { type } from "os";

export interface Act {
  id: string;
  name: string;
  description: string; // Adding this field that's referenced in the component
}

// Create a schema representation of the interface
export const ActSchema = {
  name: 'Act',
  nameAttribute: 'name',
  idType: 'string',
  properties: {
    id: { type: 'string' },
    name: { type: 'string' },
    establishment_type: { type: 'string' },
    law: { type: 'string' }
  }
};
